var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHeartEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1187 2.5C3.12046 2.5 1.83203 4.14008 1.83203 6.16558C1.83203 7.93217 2.64162 9.38361 3.85862 10.6013C5.0225 11.7658 6.53666 12.6924 7.9987 13.4389C9.46073 12.6924 10.9749 11.7658 12.1388 10.6013C13.3558 9.38361 14.1654 7.93217 14.1654 6.16558C14.1654 4.14008 12.8769 2.5 10.8787 2.5C9.7805 2.5 9.01556 3.04185 8.41472 3.9431C8.32199 4.0822 8.16587 4.16575 7.9987 4.16575C7.83152 4.16575 7.67541 4.0822 7.58267 3.9431C6.98184 3.04185 6.21689 2.5 5.1187 2.5ZM0.832031 6.16558C0.832031 3.73868 2.4285 1.5 5.1187 1.5C6.37082 1.5 7.30043 2.03647 7.9987 2.84031C8.69697 2.03647 9.62657 1.5 10.8787 1.5C13.5689 1.5 15.1654 3.73868 15.1654 6.16558C15.1654 8.27336 14.1888 9.9647 12.8461 11.3082C11.5097 12.6453 9.78674 13.6637 8.22239 14.4463C8.08158 14.5167 7.91582 14.5167 7.77501 14.4463C6.21065 13.6637 4.48767 12.6453 3.15131 11.3082C1.80857 9.9647 0.832031 8.27336 0.832031 6.16558Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeartEmpty);
export default __webpack_public_path__ + "static/media/ic-heart-empty.b04f79a09552d70e6d91ae82dd4eeaac.svg";
export { ForwardRef as ReactComponent };